import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: false,
    payrollEmpLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    successMessage: "",
    payroll_reporting_employee: [],
    employee_post_adjustment: [],
};

export const PostAdjustmentReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.PAYROLL_REPORTING_EMPLOYEE_GET_REQUEST:
            return {
                ...state,
                payrollEmpLoading: true,
                isSuccess: false,
                isError: false,
                errorMessage: "",
            };
        case ActionTypes.PAYROLL_REPORTING_EMPLOYEE_GET_SUCCESS:
            return {
                ...state,
                payrollEmpLoading: false,
                isSuccess: true,
                payroll_reporting_employee: action.payload?.data?.data || [],
                successMessage: action.payload?.message,
            };
        case ActionTypes.PAYROLL_REPORTING_EMPLOYEE_GET_ERROR:
            return {
                ...state,
                payrollEmpLoading: false,
                isError: true,
                errorMessage: action.payload?.data?.error?.[0]?.message || "Error fetching payroll reporting employees",
            };
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                isError: false,
                errorMessage: "",
                employee_post_adjustment: [],
            };
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_ADD_REQUEST:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_UPDATE_REQUEST:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
                isError: false,
                errorMessage: "",
            };
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_GET_SUCCESS:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_ADD_SUCCESS:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_UPDATE_SUCCESS:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
                successMessage: action.payload?.message,
                employee_post_adjustment: action.payload?.data?.data || [],

            };
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_GET_ERROR:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_ADD_ERROR:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_UPDATE_ERROR:
        case ActionTypes.EMPLOYEE_POST_ADJUSTMENT_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                isError: true,
                errorMessage: action.payload?.data?.error?.[0]?.message || "Error in employee post adjustment",
            };
        default:
            return state;
    }
};